const Footer = () => {
  return (
    <footer className="text-center text-sm text-gray-500 mt-20 mb-6">
      © {new Date().getFullYear()} Rohan Rajnish Khandare.
    </footer>
  );
};

export default Footer;
